import React, { FunctionComponent, SVGProps } from "react";

export const CarIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      fill="none"
      height="23"
      viewBox="0 0 30 23"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M6.69628.532638C6.98012.348179 7.31136.25 7.64987.25H22.3501c.3385-.000001.6698.098177.9536.282637.2839.18446.5081.447283.6456.756623L27.4874 9.25H29c.4142 0 .75.33579.75.75 0 .4142-.3358.75-.75.75h-1.25V21c0 .4641-.1844.9092-.5126 1.2374-.3282.3282-.7733.5126-1.2374.5126h-3c-.4641 0-.9092-.1844-1.2374-.5126-.3282-.3282-.5126-.7733-.5126-1.2374v-2.25H8.75V21c0 .4641-.18437.9093-.51256 1.2374-.32819.3282-.77331.5126-1.23744.5126H4c-.46413 0-.90925-.1844-1.23744-.5126C2.43437 21.9093 2.25 21.4641 2.25 21V10.75H1c-.414214 0-.75-.3358-.75-.75 0-.41421.335786-.75.75-.75h1.5126l3.53811-7.96074c.13748-.309339.36173-.572162.64557-.756622ZM3.75 10.75v6.5h22.5v-6.5H3.75Zm22.0959-1.5H4.15407l3.26735-7.35153c.01964-.0442.05168-.08174.09223-.10809.04055-.02635.08787-.04038.13622-.04038H22.3501c.0484 0 .0957.01403.1363.04038.0405.02635.0725.06389.0922.10809L25.8459 9.25Zm.4041 9.5h-3.5V21c0 .0663.0263.1299.0732.1768.0469.0469.1105.0732.1768.0732h3c.0663 0 .1299-.0263.1768-.0732.0469-.0469.0732-.1105.0732-.1768v-2.25Zm-19 0h-3.5V21c0 .0663.02634.1299.07322.1768.04689.0469.11047.0732.17678.0732h3c.06631 0 .12989-.0263.17678-.0732.04688-.0469.07322-.1105.07322-.1768v-2.25Zm-1-4.75c0-.4142.33579-.75.75-.75h2c.41421 0 .75.3358.75.75s-.33579.75-.75.75H7c-.41421 0-.75-.3358-.75-.75Zm14 0c0-.4142.3358-.75.75-.75h2c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-2c-.4142 0-.75-.3358-.75-.75Z"
        fill="#64748B"
        fillRule="evenodd"
      />
    </svg>
  );
};
